import * as React from 'react';
import { type FieldError as RHFFieldError } from 'react-hook-form';

type Props = Readonly<{
	// The field's entry from react-hook-form's formState.errors, e.g. errors.email.
	error?: RHFFieldError;
	// Field-specific message, shown whenever the field has any validation error.
	message: string;
}>;

/*
	Inline validation message shown under a field. react-hook-form populates
	formState.errors on submit (and keeps them current as the customer fixes
	things), and moves focus to the first invalid field, so this is what tells
	them what to correct once they've been taken there.
*/
function FieldError({ error, message }: Props): React.ReactElement | null {
	// Skip "manual" errors: those are server-side outcomes (e.g. email already in
	// use, or a password the API rejected) that are surfaced separately as a
	// root-level message, and would only show a misleading generic line here.
	if (!error || error.type === 'manual') {
		return null;
	}

	return (
		<p className="text-red-500 text-xs -mt-4 mb-3" role="alert">
			{message}
		</p>
	);
}

export default FieldError;
